import { useContext } from "react";
import { AuthContext } from "auth/AuthContext";
import { useAppDispatch } from "store/hooks";
import { useNavigate } from "react-router-dom";
import { showError } from "store/reducers/errorReducer";

export const useAuthenticator = () => {
  const { user, signOut, signIn } = useContext(AuthContext);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleAuthError = (error) => {
    if (error === "No current user") {
      signOut();
      setTimeout(() => {
        navigate("/");
      }, 200);
      return;
    }
    dispatch(
      showError(error?.response?.data?.message ?? error?.response?.data?.error ?? "Something went wrong")
    );
  };

  return {
    user,
    signOut,
    signIn,
    handleAuthError,
  };
};
